import React, { useMemo } from "react";

import ambienti from "../../../../assets/images/icons/ambienti.png";
import prodotti from "../../../../assets/images/icons/prodotti.png";
import sistema from "../../../../assets/images/icons/systema.png";

import home_icon from "../../../../assets/images/home_icon.png";

import { useNavigate } from "react-router-dom";
import "./sideMenu.css";
import AppText from "../AppText";

// ----------------------------------------------------------------------------

export default function SideMenu(props) {
  const navigate = useNavigate();
  return (
    <div className="sideMenu">
      <div className="homeIcon">
        <div className="iconCard" onClick={() => navigate("/")}>
          <img
            src={home_icon}
            style={{
              height: 30,
              width: 30,
              objectFit: "contain",
            }}
            alt="backIcon"
          />
        </div>
      </div>
      <div className="otherIcons">
        <div className="iconCard" onClick={() => navigate("/system")}>
          <img
            src={sistema}
            style={{
              height: 30,
              width: 30,

              objectFit: "contain",
            }}
            alt="backIcon"
          />

          <AppText
            bold
            noSpace
            xsmall
            style={{ width: "100%", textAlign: "center" }}
          >
            sistema
          </AppText>
          <AppText xsmall>system</AppText>
        </div>
        <div className="iconCard" onClick={() => navigate("/products")}>
          <img
            src={prodotti}
            style={{
              height: 30,
              width: 30,

              objectFit: "contain",
            }}
            alt="backIcon"
          />
          <AppText
            noSpace
            bold
            xsmall
            style={{ width: "100%", textAlign: "center" }}
          >
            prodotti
          </AppText>
          <AppText xsmall style={{ width: "100%", textAlign: "center" }}>
            products
          </AppText>
        </div>
        <div className="iconCard" onClick={() => navigate("/rooms")}>
          <img
            src={ambienti}
            style={{
              height: 30,
              width: 30,
              objectPosition: "center",
              objectFit: "contain",
            }}
            alt="backIcon"
          />
          <AppText noSpace bold xsmall>
            ambienti
          </AppText>
          <AppText xsmall>rooms</AppText>
        </div>
      </div>
    </div>
  );
}

// ----------------------------------------------------------------------------
